import { fromJS } from 'immutable';
import moment from 'moment';
import actions from '../constants';

const initial = fromJS({
  running: false,
  elapsed: 0,
});

export default (state = initial, action) => {
  switch (action.type) {
    case actions.RESET_CLOCK:
      return initial;
    case actions.SET_CLOCK:
      return state.merge({
        elapsed: action.payload.time,
      });
    case actions.START_CLOCK:
      return !state.get('running') ?
        state.merge({
          running: true,
          startedAt: action.payload.time,
        }) :
        state;
    case actions.STOP_CLOCK:
      return state.get('running') ?
        state.merge({
          running: false,
          elapsed: moment(action.payload.time).diff(moment(state.get('startedAt'))) + state.get('elapsed'),
        }).delete('startedAt') :
        state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/coding/reducers/clock.js